import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Code: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['polyline', { points: '16 18 22 12 16 6' }],
    ['polyline', { points: '8 6 2 12 8 18' }],
  ],
];

export default Code;
